// extracted by mini-css-extract-plugin
export default {"screenContent":"WelcomeScreenTwo_screenContent__TPTyG","heading":"WelcomeScreenTwo_heading__PkpDx","body":"WelcomeScreenTwo_body__PkAlG"};